"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = exports.db = exports.firebaseApp = void 0;
const firebaseconfig_1 = __importDefault(require("@upflowy/firebaseconfig")); // , { extraConfig }
const app_1 = require("firebase/app");
const firestore_1 = require("firebase/firestore");
const storage_1 = require("firebase/storage");
exports.firebaseApp = (0, app_1.initializeApp)(firebaseconfig_1.default);
if (firebaseconfig_1.default.experimentalAutoDetectLongPolling) {
    // eslint-disable-next-line no-console
    console.log('***** Using Cypress settings for Firestore *****');
    (0, firestore_1.initializeFirestore)(exports.firebaseApp, {
        experimentalAutoDetectLongPolling: firebaseconfig_1.default.experimentalAutoDetectLongPolling,
        cacheSizeBytes: firestore_1.CACHE_SIZE_UNLIMITED,
    });
}
exports.db = (0, firestore_1.getFirestore)(exports.firebaseApp);
exports.storage = (0, storage_1.getStorage)(exports.firebaseApp);
//# sourceMappingURL=firebase.js.map